export const DEMO_FEATURES224 = [
  'reward.payout', 'family.message', 'profile.edit', 'consent.change',
  'account.security', 'data.export', 'mission.review', 'content.publish',
] as const;
export type DemoFeature224 = (typeof DEMO_FEATURES224)[number];

export const demoFeatureLabels224: Record<DemoFeature224, string> = {
  'reward.payout': '보상·용돈 지급',
  'family.message': '가족 응원 보내기',
  'profile.edit': '자녀 프로필·PIN 변경',
  'consent.change': '동의 변경',
  'account.security': '비밀번호·이메일 인증',
  'data.export': '데이터 내보내기',
  'mission.review': '미션 승인',
  'content.publish': '콘텐츠 게시',
};

export const demoFeatureNotes224: Record<DemoFeature224, string> = {
  'reward.payout': '실제 돈이 오가는 것처럼 보이는 동작을 막습니다.',
  'family.message': '체험 중 보낸 응원이 남지 않게 합니다.',
  'profile.edit': '체험 계정의 이름·PIN이 바뀌지 않게 합니다.',
  'consent.change': '동의 기록이 체험으로 오염되지 않게 합니다.',
  'account.security': '비밀번호 재설정 메일이 나가지 않게 합니다.',
  'data.export': '전체 백업 내려받기를 막습니다.',
  'mission.review': '승인 결과가 남지 않게 합니다.',
  'content.publish': '체험에서 실제 콘텐츠가 게시되지 않게 합니다.',
};

/** The client greys the control out; the server is what actually refuses. */
export function isRestricted224(restricted: readonly string[], feature: DemoFeature224): boolean {
  return restricted.includes(feature);
}
